export const formatDataPersonalized = stringData => {
  if (!stringData) return stringData;
  const parser = new DOMParser();
  const svgDoc = parser.parseFromString(stringData, 'application/xml');
  const gElements = Array.from(svgDoc.querySelectorAll('g'));
  const svgRoot = svgDoc.querySelector('svg');
  let firstImageG = null;
  const otherImageGs = [];
  const nonImageGs = [];
  gElements.forEach(g => {
    if (g.querySelector('image')) {
      if (!firstImageG) {
        firstImageG = g;
      } else {
        otherImageGs.push(g);
      }
    } else {
      nonImageGs.push(g);
    }
  });
  gElements.forEach(g => g.remove());
  otherImageGs.forEach(g => svgRoot.appendChild(g));
  if (firstImageG) svgRoot.appendChild(firstImageG);
  nonImageGs.forEach(g => svgRoot.appendChild(g));
  const serializer = new XMLSerializer();
  const newSvgString = serializer.serializeToString(svgDoc);
  return newSvgString;
};
